import styled from "styled-components";
import { SpaceProps, grid, GridProps, space } from "styled-system";

import { Box } from "../../components/Box";
import ScheduledTimeWidget from "./ScheduledTimeWidget";
import TimeByTagWidget from "./TimeByTagWidget";
import { Text } from "../../components/Text";
import React, { useState } from "react";
import { Flex } from "components/Flex";
import { BlocksByDayWidget } from "./BlocksByDay";
import ScheduledBlocksWidget from "./ScheduledBlocksWidget";
import { MostPopularTagWidget } from "./MostPopularTag";
import { PrioritiesWidget } from "./PrioritiesWidget";
import { DateRange, DateRangeControl } from "components/DateRangeControl";

const Grid = styled.div<GridProps & SpaceProps>`
  display: grid;
  ${grid};
  ${space};
`;

const Title = styled(Text)`
  & small {
    color: ${(props) => props.theme.colors.primary};
    margin-left: 3px;
    font-size: 50%;
    vertical-align: super;
  }
`;

const getDefaultDateRange = (): DateRange => 30;

const Insights = () => {
  const [dateRange, setDateRange] = useState<DateRange>(getDefaultDateRange());

  return (
    <Box p={[2, 3]}>
      <Flex mb={2} borderBottom={1} pb={2} justifyContent="space-between">
        <Title fontSize={4} fontWeight={600}>
          Insights
          <small>BETA</small>
        </Title>
        <DateRangeControl value={dateRange} onChange={setDateRange} />
      </Flex>
      <Grid
        gridGap={[2, 3]}
        gridTemplateColumns={["100%", "1fr 1fr 1fr"]}
        mb={2}
      >
        <ScheduledTimeWidget range={dateRange} />
        <ScheduledBlocksWidget range={dateRange} />
        <MostPopularTagWidget range={dateRange} />
      </Grid>
      <Grid
        gridGap={[2, 3]}
        gridTemplateColumns={["100%", "100%", "100%", "1fr 1fr"]}
        gridTemplateRows={["auto", "auto", "auto", "minmax(400px 700px)"]}
      >
        <BlocksByDayWidget range={dateRange} />
        <PrioritiesWidget range={dateRange} />
        <TimeByTagWidget />
      </Grid>
    </Box>
  );
};

export default Insights;
